import { INodeComponent, INode } from './types'
import { types, getRoot } from 'mobx-state-tree'
import { ReferencePoint } from 'src/constants/referencePoints'
import { Side } from 'src/constants/sides'
import { RouteState } from 'src/constants/routes'
import { IRoot } from 'src/api/stores/Root/types'

export type FocusOptions = {
  side?: Side
  referencePoint: ReferencePoint
}

export const NodeComponent: INodeComponent = types
  .model()
  .views(self => {
    const root = getRoot<IRoot>(self)
    return {
      get routeState() {
        return root.routeState as RouteState
      }
    }
  })
  .volatile(self => ({
    focused: false as boolean,
    focusedReferencePoint: null as ReferencePoint | null,
    focusedSide: null as Side | null
  }))
  .actions(self => ({
    focusReferencePoint(options: FocusOptions) {
      self.focusedReferencePoint = options.referencePoint
      if (options.side) self.focusedSide = options.side
    },
    focus(options?: Partial<FocusOptions>) {
      if (options) {
        if (options.referencePoint) self.focusedReferencePoint = options.referencePoint
        if (options.side) self.focusedSide = options.side
      }
      self.focused = true
    },
    blur() {
      self.focused = false
      self.focusedSide = null
      self.focusedReferencePoint = null
    },
    
  }))
